module.exports = __webpack_public_path__ + "img/spid-ico-circle-bb.14efd2a9.svg";